<script>
    import _ from 'lodash'
    import ListUtils from '@/utils/list'
    import NumberUtils from '@/utils/number'
    import OrgService from '@/request/user/org'
    import UserService from '@/request/user/user'
    import DiagnosisService from '@/request/dictionary/diagnosis'
    import OperatingService from '@/request/dictionary/operating'
    export default {
        name: 'DatabankNormcaseEdit',
        props: {
            value: {
                type: Object,
                default () {
                    return {}
                }
            }
        },
        data () {
            return {
                orgSelection: [],
                orgProps: {
                    value: 'id',
                    label: 'name',
                    children: 'children'
                },
                oidPath: [],
                default: {
                    publicType: 1
                },
                back: {},
                normcase: {},
                diagnoseSelection: [],
                diagnoses: [],
                diagnoseLoading: false,
                operatingSelection: [],
                operatings: [],
                operatingLoading: false,
                doctorSelection: [],
                doctorLoading: false,
                operator: null,
                operatorOrg: null,
                hospitalSelection: [],
                publicHospitals: [],
                isSelectDoctor: false,
                isSelect: false
            }
        },
        computed: {},
        created: function () {
            this.init()
            this.listOrg()
            this.listHospital()
        },
        mounted: function () {},
        beforeDestroy () {},
        watch: {
            value () {
                this.init()
            },
            normcase: {
                deep: true,
                handler () {
                    this.updateData()
                }
            },
            diagnoses () {
                this.updateDiagnos()
            },
            operatings () {
                this.updateOperating()
            },
            // oidPath (val) {
            //   let oid = null
            //   if (!_.isEmpty(val)) {
            //     oid = _.parseInt(_.last(val))
            //   }
            //   this.updateOrg(oid)
            // },
            operator (newVal, oldVal) {
                if (newVal === oldVal) {
                    return
                }
                this.updateDoctor()
            },
            publicHospitals (val) {
                let publicHospital = _.isEmpty(val) ? null : _.join(val)
                if (!publicHospital) {
                    _.assign(this.normcase, {
                        publicDepartment: null,
                        publicHospital: null
                    })
                }
                this.$set(this.normcase, 'publicHospital', publicHospital)
            },
            'normcase.publicType': function (val) {
                if (val !== 2) {
                    this.publicHospitals = []
                }
            },
            'normcase.orgName': function (val, old) {
                if (this.isSelect) {
                    this.isSelect = false
                    return
                }
                if (!val) {
                    _.assign(this.normcase, {
                        oid: null,
                        hid: null,
                        hname: null
                    })
                }
                if (!old) {
                    return
                }
                _.assign(this.normcase, {
                    oid: null,
                    hid: null,
                    hname: null
                })
            },
            'normcase.operatorName': function (val, old) {
                if (this.isSelectDoctor) {
                    this.isSelectDoctor = false
                    return
                }
                if (!val) {
                    _.assign(this.normcase, {
                        operator: null,
                        operatorName: null
                    })
                }
                if (!old) {
                    return
                }
                _.assign(this.normcase, {
                    operator: null
                })
            }
        },
        methods: {
            updateData () {
                if (_.isEqual(this.value, this.normcase)) {
                    return
                }
                this.$emit('input', this.normcase)
            },
            init () {
                this.normcase = _.clone(this.value || {})
                _.defaultsDeep(this.normcase, this.default)
                this.back = _.cloneDeep(this.normcase)
                this.initDoctor()
                this.initDiagnos()
                this.initOperating()
                this.publicHospitals = NumberUtils.idsFromString(this.normcase.publicHospital)
                // if (!_.isEmpty(this.orgSelection)) {
                //   let path = ListUtils.findIdFromTree(this.orgSelection, this.normcase.oid)
                //   this.oidPath = _.cloneDeep(path)
                // } else {
                //   this.listOrg()
                // }
            },
            initDoctor () {
                if (_.isEmpty(this.normcase.operator) && _.isEmpty(this.normcase.operatorName)) {
                    this.operator = null
                    return
                }
                let name = this.normcase.operatorName
                if (!_.isEmpty(this.operator) && this.operator === name) {
                    this.doctorSelection = [{
                        id: name,
                        name: name
                    }]
                    return
                }
                let id = NumberUtils.idFromString(this.normcase.operator) || null
                if (id) {
                    this.doctorSelection = [{
                        id: id,
                        name: name
                    }]
                }
                this.operator = id
            },
            initDiagnos () {
                if (_.isEmpty(this.normcase.diagnose)) {
                    this.diagnoses = []
                    return
                }
                let idstr = this.normcase.diagnose
                let names = _.split(this.normcase.diagnoseNames, ',')
                let ids = NumberUtils.idsFromString(idstr)
                let cids = this.diagnoses
                if (_.join(ids) === _.join(cids)) {
                    return
                }
                if (_.isEmpty(ids)) {
                    this.diagnoses = []
                    _.assign(this.normcase, {
                        diagnose: null,
                        diagnoseNames: null
                    })
                    return
                }
                let datas = []
                let i = 0
                _.forEach(ids, id => {
                    datas.push({
                        id: id,
                        name: names[i++]
                    })
                })
                this.diagnoseSelection = _.clone(datas)
                this.diagnoses = _.clone(ids)
            },
            initOperating () {
                if (_.isEmpty(this.normcase.operatingIds)) {
                    this.operatings = []
                    return
                }
                let idstr = this.normcase.operatingIds
                let names = _.split(this.normcase.operatingNames, ',')
                let ids = NumberUtils.idsFromString(idstr)
                let cids = this.operatings
                if (_.join(ids) === _.join(cids)) {
                    return
                }
                if (_.isEmpty(ids)) {
                    this.operatings = []
                    _.assign(this.normcase, {
                        operatingIds: null,
                        operatingNames: null
                    })
                    return
                }
                let datas = []
                let i = 0
                _.forEach(ids, id => {
                    datas.push({
                        id: id,
                        name: names[i++]
                    })
                })
                this.operatingSelection = _.clone(datas)
                this.operatings = _.clone(ids)
            },
            updateDiagnos () {
                let oldDiagnos = this.normcase.diagnose
                let joinStr = null
                if (!_.isEmpty(this.diagnoses)) {
                    if (oldDiagnos && oldDiagnos.indexOf('(') === 0) {
                        joinStr = '(' + _.join(this.diagnoses, ')(') + ')'
                    } else {
                        joinStr = _.join(this.diagnoses)
                    }
                }
                if (oldDiagnos === joinStr) {
                    return
                }
                if (!joinStr) {
                    _.assign(this.normcase, {
                        diagnose: null,
                        diagnoseNames: null
                    })
                    return
                }
                this.$set(this.normcase, 'diagnose', joinStr)
                DiagnosisService.list({
                    ids: _.join(this.diagnoses)
                }).then(res => {
                    let ds = res.result || []
                    if (_.isEmpty(ds)) {
                        return
                    }
                    let names = new Array(ds.length)
                    let index = -1
                    _.forEach(ds, item => {
                        index = _.indexOf(this.diagnoses, item.id)
                        if (index < 0) {
                            return
                        }
                        names[index] = item.name
                    })
                    this.$set(this.normcase, 'diagnoseNames', _.join(names))
                })
            },
            updateOperating () {
                let oldOperating = this.normcase.operatingIds
                let joinStr = null
                if (!_.isEmpty(this.operatings)) {
                    if (oldOperating && oldOperating.indexOf('(') === 0) {
                        joinStr = '(' + _.join(this.operatings, ')(') + ')'
                    } else {
                        joinStr = _.join(this.operatings)
                    }
                }
                if (oldOperating === joinStr) {
                    return
                }
                if (!joinStr) {
                    _.assign(this.normcase, {
                        operatingIds: null,
                        operatingNames: null
                    })
                    return
                }
                this.$set(this.normcase, 'operatingIds', joinStr)
                OperatingService.list({
                    ids: _.join(this.operatings)
                }).then(res => {
                    let os = res.result || []
                    if (_.isEmpty(os)) {
                        return
                    }
                    let names = new Array(os.length)
                    let index = -1
                    _.forEach(os, item => {
                        index = _.indexOf(this.operatings, item.id)
                        if (index < 0) {
                            return
                        }
                        names[index] = item.name
                    })
                    this.$set(this.normcase, 'operatingNames', _.join(names))
                })
            },
            updateDoctor () {
                let oldid = NumberUtils.idFromString(this.normcase.operator) || null
                if (this.operator === oldid) {
                    return
                }
                if (!this.operator) {
                    _.assign(this.normcase, {
                        operator: null,
                        operatorName: null
                    })
                    return
                }
                if (_.isString(this.operator)) {
                    _.assign(this.normcase, {
                        operator: null,
                        operatorName: this.operator
                    })
                    return
                }
                UserService.load(this.operator).then(res => {
                    let data = res.result || null
                    if (!data) {
                        return
                    }
                    let nc = _.clone(this.normcase)
                    _.assign(nc, {
                        operator: '(' + data.id + ')',
                        operatorName: data.name
                    })
                    this.normcase = _.clone(nc)
                })
            },
            updateOrg (oid) {
                if (!oid) {
                    _.assign(this.normcase, {
                        oid: null,
                        orgName: null,
                        hid: null,
                        hname: null
                    })
                    return
                }
                if (oid === this.normcase.oid) {
                    return
                }
                let oname = null
                let hid = null
                let hname = null
                let orgs = ListUtils.findFromTree(this.orgSelection, oid)
                if (!_.isEmpty(orgs)) {
                    let org = orgs.pop()
                    oname = org.name
                    while (org && org.otsn !== 'lx0001001') {
                        org = orgs.pop()
                    }
                    if (org) {
                        hid = org.id
                        hname = org.name
                    }
                }
                _.assign(this.normcase, {
                    oid: oid,
                    orgName: oname,
                    hid: hid,
                    hname: hname
                })
            },
            listDiagnosis (query) {
                let self = this
                self.diagnoseLoading = true
                DiagnosisService.find({
                    pageOffset: 1,
                    pageSize: 100
                }, {
                    match: query || null
                }).then(res => {
                    let data = res.result['content'] || []
                    if (query) {
                        let evens = _.remove(data, item => {
                            return item.name === query
                        })
                        if (!_.isEmpty(evens)) {
                            data = _.concat(evens, data)
                        }
                    }
                    data = _.uniqBy(data, 'name')
                    self.diagnoseSelection = _.cloneDeep(data)
                    self.diagnoseLoading = false
                }, () => {
                    self.diagnoseSelection = []
                    self.diagnoseLoading = false
                })
            },
            listOperating (query) {
                let self = this
                self.operatingLoading = true
                OperatingService.find({
                    pageOffset: 1,
                    pageSize: 100
                }, {
                    match: query || null
                }).then(res => {
                    let data = res.result['content'] || []
                    if (query) {
                        let evens = _.remove(data, item => {
                            return item.name === query
                        })
                        if (!_.isEmpty(evens)) {
                            data = _.concat(evens, data)
                        }
                    }
                    data = _.uniqBy(data, 'name')
                    self.operatingSelection = _.cloneDeep(data)
                    self.operatingLoading = false
                }, () => {
                    self.operatingSelection = []
                    self.operatingLoading = false
                })
            },
            listOrg () {
                let self = this
                OrgService.listOrg({
                    typeSns: 'lx0001,lx0001001,lx0001001001',
                    descendant: 1,
                    parents: 1
                }).then(res => {
                    let orgs = res.result ? res.result : []
                    self.orgSelection = _.clone(ListUtils.listToTree(orgs))
                    // if (this.normcase.oid && _.isEmpty(this.oidPath)) {
                    //   let path = ListUtils.findIdFromTree(this.orgSelection, this.normcase.oid)
                    //   this.oidPath = _.cloneDeep(path)
                    // }
                })
            },
            querySearchOrg (queryString, callback) {
                OrgService.listOrg({
                    descendant: 1,
                    parents: 1,
                    typeSns: 'lx0001001',
                    match: queryString
                }).then(res => {
                    let result = res.result || []
                    callback(result)
                })
            },
            handleSelectOrg (org) {
                let oid = org ? org.id : null
                this.isSelect = true
                this.updateOrg(oid)
            },
            querySearchDoctor (queryString, callback) {
                UserService.list({
                    match: queryString
                }).then(res => {
                    let result = res.result || []
                    callback(result)
                })
            },
            handleSelectDoctor (user) {
                if (!user) {
                    _.assign(this.normcase, {
                        operator: null,
                        operatorName: null
                    })
                    return
                }
                this.isSelectDoctor = true
                _.assign(this.normcase, {
                    operator: user.id,
                    operatorName: user.name
                })
            },
            listDoctor (query) {
                this.doctorLoading = true
                UserService.list({
                    match: query
                }).then(res => {
                    this.doctorSelection = _.clone(res.result || [])
                }).finally(() => {
                    this.doctorLoading = false
                })
            },
            listHospital () {
                let self = this
                OrgService.listOrg({
                    parents: 1,
                    typeSns: 'lx0001001'
                }).then(res => {
                    self.hospitalSelection = _.cloneDeep(res.result || [])
                }, () => {
                    self.hospitals = []
                })
            },
            save () {}
        }
    }
</script>

<template>
    <el-form ref="normcaseForm" label-position="right" label-width="100px" :model="normcase">
        <!-- {{diagnoses}}<br>
        {{operatings}}<br>
        {{operator}}<br>
        {{publicHospitals}}<br>
        {{normcase}}<br> -->
        <el-form-item label="标题" prop="title" :rules="[{ required: true, message: '标题不能为空' }]">
            <el-input v-model="normcase.title" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="医院" prop="orgName" :rules="[{ required: true, message: '医院不能为空' }]">
            <el-autocomplete
                    v-model="normcase.orgName"
                    clearable
                    :fetch-suggestions="querySearchOrg"
                    value-key="name"
                    placeholder="请输入组织名称"
                    @select="handleSelectOrg"
                    style="width: 100%;"
            ></el-autocomplete>
        </el-form-item>
        <el-form-item label="医生" prop="operatorName">
            <el-autocomplete
                    v-model="normcase.operatorName"
                    clearable
                    :fetch-suggestions="querySearchDoctor"
                    value-key="name"
                    placeholder="输入医生姓名(支持新建)"
                    @select="handleSelectDoctor"
                    style="width: 100%;"
            ></el-autocomplete>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
            <el-radio-group v-model="normcase.sex">
                <el-radio :label="parseInt(1)" border>男</el-radio>
                <el-radio :label="parseInt(2)" border>女</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="年龄" prop="age" :rules="[{ type: 'number', message: '年龄必须为数字值'}]">
            <el-input type="age" v-model.number="normcase.age" placeholder="请输入患者年龄"></el-input>
        </el-form-item>
        <el-form-item label="诊断" prop="diagnose">
            <el-select
                    v-model="diagnoses"
                    clearable
                    multiple
                    filterable
                    remote
                    default-first-option
                    placeholder="输入关键词查找诊断"
                    :remote-method="listDiagnosis"
                    :loading="diagnoseLoading"
                    @focus="listDiagnosis()"
                    style="width: 100%;">
                <el-option
                        v-for="item in diagnoseSelection"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="术式" prop="operatings">
            <el-select
                    v-model="operatings"
                    clearable
                    multiple
                    filterable
                    remote
                    default-first-option
                    placeholder="输入关键词查找术式"
                    :remote-method="listOperating"
                    :loading="operatingLoading"
                    @focus="listOperating()"
                    style="width: 100%;">
                <el-option
                        v-for="item in operatingSelection"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="公开范围" prop="publicType">
            <el-radio-group v-model="normcase.publicType">
                <el-radio-button :label="parseInt(1)" border>公开</el-radio-button>
                <el-radio-button :label="parseInt(2)" border>医院</el-radio-button>
                <!-- <el-radio-button :label="parseInt(3)" border>科室</el-radio-button> -->
                <el-radio-button :label="parseInt(0)" border>个人</el-radio-button>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="公开医院" prop="publicHospitals" v-if="normcase.publicType === 2">
            <el-select v-model="publicHospitals" multiple placeholder="请选择医院" style="width: 100%;">
                <el-option
                        v-for="item in hospitalSelection"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>
    </el-form>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
